import {
  AI_ANALYSIS_FETCH_REQUEST,
  AI_ANALYSIS_FETCH_SUCCESS,
  AI_ANALYSIS_FETCH_FAILURE,
  AI_ANALYSIS_FETCH_NOT_FOUND,
  AI_ANALYSIS_RETRY_REQUEST,
  AI_ANALYSIS_RETRY_SUCCESS,
  AI_ANALYSIS_RETRY_FAILURE,
  AI_ANALYSIS_REVIEW_REQUEST,
  AI_ANALYSIS_REVIEW_SUCCESS,
  AI_ANALYSIS_REVIEW_FAILURE,
  AI_ANALYSIS_CONFIRM_REQUEST,
  AI_ANALYSIS_CONFIRM_SUCCESS,
  AI_ANALYSIS_CONFIRM_FAILURE,
} from './aiAnalysisActions';

export function aiAnalyses(state = {}, action) {
  switch (action.type) {
    case AI_ANALYSIS_FETCH_REQUEST:
    case AI_ANALYSIS_RETRY_REQUEST:
    case AI_ANALYSIS_REVIEW_REQUEST:
    case AI_ANALYSIS_CONFIRM_REQUEST:
      return {
        ...state,
        [action.quoteVersionId]: {
          ...(state[action.quoteVersionId] || {}),
          loading: true,
          error: false,
          notFound: false,
        },
      };
    case AI_ANALYSIS_FETCH_SUCCESS:
      return {
        ...state,
        [action.quoteVersionId]: { ...action.analysis, loading: false },
      };
    case AI_ANALYSIS_FETCH_FAILURE:
      return {
        ...state,
        [action.quoteVersionId]: { loading: false, error: true },
      };
    case AI_ANALYSIS_FETCH_NOT_FOUND:
      return {
        ...state,
        [action.quoteVersionId]: {
          loading: false,
          notFound: true,
          automaticAnalysis: action.automaticAnalysis,
        },
      };
    case AI_ANALYSIS_RETRY_SUCCESS:
      return {
        ...state,
        [action.quoteVersionId]: { ...(action.analysis || { status: 'pending' }), loading: false },
      };
    case AI_ANALYSIS_REVIEW_SUCCESS:
      return {
        ...state,
        [action.quoteVersionId]: { ...action.analysis, loading: false },
      };
    case AI_ANALYSIS_REVIEW_FAILURE:
    case AI_ANALYSIS_RETRY_FAILURE:
      return {
        ...state,
        [action.quoteVersionId]: {
          ...(state[action.quoteVersionId] || {}),
          loading: false,
        },
      };
    case AI_ANALYSIS_CONFIRM_SUCCESS:
      return {
        ...state,
        [action.quoteVersionId]: { ...(action.analysis || state[action.quoteVersionId] || {}), loading: false },
      };
    case AI_ANALYSIS_CONFIRM_FAILURE:
      return {
        ...state,
        [action.quoteVersionId]: {
          ...(state[action.quoteVersionId] || {}),
          loading: false,
        },
      };
    default:
      return state;
  }
}
